module.exports = __webpack_public_path__ + "img/rs_whiteP-patch3.b33378f.png";